<template>
    <div class="row">
        <div class="col-md-12 text-center">
            <errors v-if="errors_msg?.message">
                {{ errors_msg.message }}
            </errors>
             <p class="akkurate-danger small">{{ acc_error }}</p>
        </div>
        <div class="row">
            <div class="col">
                <b-form-group class="akkurate-dark small" label="Entry type" v-slot="{ ariaDescribedby }">
                    <b-form-radio class="akkurate-dark" v-b-tooltip.hover="{ variant: 'info' }"
                        title="Deposit to Teller" v-model="form.payment_selected"
                        :aria-describedby="ariaDescribedby" name="type" value="RECEIPT_ENTRY">Receipt
                        Entry</b-form-radio>
                    <b-form-radio class="akkurate-dark" v-b-tooltip.hover="{ variant: 'info' }"
                        title="Withdrawal from Teller" v-model="form.payment_selected"
                        :aria-describedby="ariaDescribedby" name="type" value="PAYMENT_ENTRY">Payment
                        Entry</b-form-radio>
                </b-form-group>
            </div>
            <div class="col mt-auto">
                <label class="akkurate-dark small" for="amount">Transaction
                    Date <star></star></label>
                <b-form-input type="date" v-model="form.trans_date" class="mt-2 field-container fields"
                    required></b-form-input>
            </div>
        </div>
        <hr class="mt-2" />
        <div class="akkurate-dark fw-bold">Accounts</div>
        <div class="row mt-2" v-for="(field, index) in entities" :key="index">
            <div class="col mt-auto">
                <b-form-group>
                    <label class="akkurate-dark small" for="coa">COA
                        <star></star>
                    </label>
                    <multiselect v-model="field.coa_subhead" name="coa_subhead" :options="coaSubheadOptions"
                        class="mt-2 field-container" label="code" :custom-label="customLabel" required>
                    </multiselect>
                    <errors v-if="errors.account_type">
                        {{ errors.account_type[0] }}
                    </errors>
                </b-form-group>
            </div>
            <div class="col mt-auto">
                <label class="akkurate-dark small" for="amount">Amount
                    <star></star>
                </label>
                <b-form-group label-for="amount">
                    <b-form-input id="amount" name="amount" class="mt-2 field-container fields" type="number"
                        placeholder="Enter Amount" step="any" v-model="field.amount" required></b-form-input>
                    <errors v-if="errors.amount">
                        {{ errors.amount[0] }}
                    </errors>
                </b-form-group>
            </div>

            <div class="col mt-auto">
                <b-form-group>
                    <label class="akkurate-dark small" for="dr_amount">Description <star></star>
                    </label>
                    <b-form-input id="coa_description" v-model="field.coa_description" name="coa_description"
                        class="mt-2 field-container fields" placeholder="Enter COA Description" type="text"
                        required></b-form-input>
                    <errors v-if="errors.coa_description">
                        {{ errors.coa_description[0] }}
                    </errors>
                </b-form-group>
            </div>
            <div class="col-1 mt-auto">
                <a title="Delete" class="btn btn-sm akkurate-danger-btn text-white" @click="removeField(index)">
                    <span class="akkurate-small"><font-awesome-icon :icon="['fas', 'trash']" /></span>
                </a>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col-md-12">
                <button type="button" @click="addAccount" class="btn akkurate-green-btn text-white btn-size">
                    <font-awesome-icon class="me-2" :icon="['fas', 'plus']" />
                    Add
                </button>
            </div>
        </div>
       
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
export default {
    components:{
        Multiselect
    },
    props:[
        'errors_msg',
        'form',
        'coaSubheadOptions',
        'errors',
        'entities',
        'acc_error'
    ],
    methods:{
         addAccount() {
            if (this.entities.length < 1) {
                this.acc_error = "account can not be lesser then one"
                // this.isSaving = true
            } else {
                this.acc_error = ""
                // this.isSaving = false
            }
            if (this.entities.length > 0) {
                this.entities.push({ amount: "", coa_subhead: { id: "", name: "", code: "" } });

            }
        },
        removeField(index) {
            if (this.entities.length == 1) {
                this.acc_error = "account can not be lesser then one"
                // this.isSaving = true

            } else {
                this.acc_error = ""
                // this.isSaving = false
            }
            if (this.entities.length > 1) {
                this.entities.splice(index, 1);
            }
        },
        customLabel({ code, name, coabranch }) {
            return `${code} - ${name} - ${coabranch?.name ?? ""}`
        },
        // entryClicked(event) {
        //     if (event === "RECEIPT_ENTRY") {
        //         this.source = "Source (Debit)";
        //         this.destination = "Destination (Credit)";
        //     } else if (event == "PAYMENT_ENTRY") {
        //         this.source = "Destination (Credit)";
        //         this.destination = "Source (Debit)";
        //     } else {
        //         this.source = "Source (Debit)";
        //         this.destination = "Destination (Credit)";
        //     }
        // },
    }
}
</script>
